import { useTheme } from '@chakra-ui/react';
import { useCallback } from 'react';

const DEPTH_FACTOR = 1; // this must exist in theme.space

const DEPTHS = {
  sm: 0.5,
  md: 1,
  lg: 2,
};

export const useTableV2IndentationStyle = (
  depthSize: keyof typeof DEPTHS = 'md',
) => {
  const theme = useTheme();

  return useCallback(
    (depth: number) => {
      const depthBase = theme.space[DEPTH_FACTOR];
      return `calc(2 * ${depthBase} * ${depth} * ${DEPTHS[depthSize]} + ${theme.space[1]})`;
    },
    [theme, depthSize],
  );
};
